import { extractWorkspaceGroup, extractWorkspaceName, getBudgetAreaFromManagementGroup, getDataPlaneFormattedPath, getExperimentationGroupIdFromPath, getExperimentationGroupLabel, getExperimentationPathFromId, getManagementGroupLevels, getRootExperimentationGroup, getTenantFromManagementGroup, isClassicWorkspaceById, isClassicWorkspaceByName, isManagementGroupNameValid, isMsftWorkspaceById, isRootExperimentationGroup, isRootManagementGroup, isTestMsftWorkspaceById, splitManagementGroupPath } from "./ManagementGroup.utils.js";
export {
  extractWorkspaceGroup,
  extractWorkspaceName,
  getBudgetAreaFromManagementGroup,
  getDataPlaneFormattedPath,
  getExperimentationGroupIdFromPath,
  getExperimentationGroupLabel,
  getExperimentationPathFromId,
  getManagementGroupLevels,
  getRootExperimentationGroup,
  getTenantFromManagementGroup,
  isClassicWorkspaceById,
  isClassicWorkspaceByName,
  isManagementGroupNameValid,
  isMsftWorkspaceById,
  isRootExperimentationGroup,
  isRootManagementGroup,
  isTestMsftWorkspaceById,
  splitManagementGroupPath
};
//# sourceMappingURL=index.js.map
